angular.module('transactionsApp').component('syncToolTip', {
    bindings: {
      selected: '<',
      message: '<'
    },
    template: '<div class="btn btn-default no-border" tooltip-placement="{{$ctrl.selected}}" uib-tooltip="{{$ctrl.message}}"></div>'
  });